/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogPropertyBulkImportBodyParams } from '../models/CatalogPropertyBulkImportBodyParams';
import type { CatalogPropertyBulkImportResponse } from '../models/CatalogPropertyBulkImportResponse';
import type { CatalogPropertyCreateBodyParams } from '../models/CatalogPropertyCreateBodyParams';
import type { CatalogPropertyCreateResponse } from '../models/CatalogPropertyCreateResponse';
import type { CatalogPropertyDeactivateBySourceBodyParams } from '../models/CatalogPropertyDeactivateBySourceBodyParams';
import type { CatalogPropertyDeactivateBySourceResponse } from '../models/CatalogPropertyDeactivateBySourceResponse';
import type { CatalogPropertyDeleteResponse } from '../models/CatalogPropertyDeleteResponse';
import type { CatalogPropertyFileImportBodyParams } from '../models/CatalogPropertyFileImportBodyParams';
import type { CatalogPropertyGetResponse } from '../models/CatalogPropertyGetResponse';
import type { CatalogPropertyListResponse } from '../models/CatalogPropertyListResponse';
import type { CatalogPropertyPreviewsBodyParams } from '../models/CatalogPropertyPreviewsBodyParams';
import type { CatalogPropertyPreviewsResponse } from '../models/CatalogPropertyPreviewsResponse';
import type { CatalogPropertySearchResponse } from '../models/CatalogPropertySearchResponse';
import type { CatalogPropertySheetImportBodyParams } from '../models/CatalogPropertySheetImportBodyParams';
import type { CatalogPropertyUpdateBodyParams } from '../models/CatalogPropertyUpdateBodyParams';
import type { CatalogPropertyUpdateResponse } from '../models/CatalogPropertyUpdateResponse';
import type { GlobalBrokersMediaImportBodyParams } from '../models/GlobalBrokersMediaImportBodyParams';
import type { PropertyGlobalBrokersMediaImportResponse } from '../models/PropertyGlobalBrokersMediaImportResponse';
import type { SearcherDocumentSearchBodyParams } from '../models/SearcherDocumentSearchBodyParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CatalogPropertiesService {
    /**
     * Load bounded property summaries and their preview image URLs.
     * @param requestBody - TSOA-normalized IDs; the shared schema enforces positive INT4 bounds and up to fifty entries before deduplication.
     * @returns CatalogPropertyPreviewsResponse One authorized or generically unavailable preview per distinct ID.
     * @throws ApiError
     */
    public static getPropertyPreviews(
        requestBody: CatalogPropertyPreviewsBodyParams,
    ): CancelablePromise<CatalogPropertyPreviewsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/previews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns CatalogPropertyGetResponse Ok
     * @throws ApiError
     */
    public static getProperty(
        id: number,
    ): CancelablePromise<CatalogPropertyGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/properties/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns CatalogPropertyUpdateResponse Ok
     * @throws ApiError
     */
    public static updateProperty(
        id: number,
        requestBody: CatalogPropertyUpdateBodyParams,
    ): CancelablePromise<CatalogPropertyUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/catalog/properties/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @returns CatalogPropertyDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteProperty(
        id: number,
    ): CancelablePromise<CatalogPropertyDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/catalog/properties/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param tenantId
     * @returns CatalogPropertyListResponse Ok
     * @throws ApiError
     */
    public static listProperties(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        tenantId?: string,
    ): CancelablePromise<CatalogPropertyListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/catalog/properties',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyCreateResponse Ok
     * @throws ApiError
     */
    public static createProperty(
        requestBody: CatalogPropertyCreateBodyParams,
    ): CancelablePromise<CatalogPropertyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertySearchResponse Ok
     * @throws ApiError
     */
    public static searchProperties(
        requestBody: SearcherDocumentSearchBodyParams,
    ): CancelablePromise<CatalogPropertySearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importProperties(
        requestBody: CatalogPropertyBulkImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importWasi(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/wasi/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importTwoClics(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/2clics/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importTopPropiedades(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/toppropiedades/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Enqueue an asynchronous property import for the given provider.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static enqueuePropertyImport(
        requestBody: CatalogPropertyFileImportBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/imports/enqueue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Deactivate active properties by external source system.
     * @param requestBody
     * @returns CatalogPropertyDeactivateBySourceResponse Ok
     * @throws ApiError
     */
    public static deactivatePropertiesBySource(
        requestBody: CatalogPropertyDeactivateBySourceBodyParams,
    ): CancelablePromise<CatalogPropertyDeactivateBySourceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/imports/deactivate-by-source',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importProp360(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/prop360/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Execute a Kutt import using an already parsed sheet.
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importKutt(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/kutt/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importKiteProp(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/kiteprop/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Execute an Ilist import using an already parsed sheet.
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importIlist(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/ilist/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Imports one normalized Global Brokers sheet chunk.
     * @param requestBody
     * @returns CatalogPropertyBulkImportResponse Ok
     * @throws ApiError
     */
    public static importGlobalBrokers(
        requestBody: CatalogPropertySheetImportBodyParams,
    ): CancelablePromise<CatalogPropertyBulkImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/globalbrokers/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Hydrates and reconciles remote images after the core property exists.
     * @param requestBody
     * @returns PropertyGlobalBrokersMediaImportResponse Ok
     * @throws ApiError
     */
    public static importGlobalBrokersMedia(
        requestBody: GlobalBrokersMediaImportBodyParams,
    ): CancelablePromise<PropertyGlobalBrokersMediaImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/catalog/properties/globalbrokers/media/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
}
